import { Component, OnInit } from '@angular/core';
import { DataserviceService } from '../dataservice.service';

@Component({
  selector: 'app-holdback-bank',
  templateUrl: './holdback-bank.component.html',
  styleUrls: ['./holdback-bank.component.css']
})
export class HoldbackBankComponent implements OnInit {
  pending: any[] = [];
  released: any[] = [];
  forfeited: any[] = [];
  totals = { pending: 0, released: 0, forfeited: 0 };

  constructor(private data: DataserviceService) {}

  ngOnInit() {
    const user = JSON.parse(localStorage.getItem('user')!);
    this.data.getHoldbackBank(user.id).subscribe((res: any) => {
      this.pending = res.pending || [];
      this.released = res.released || [];
      this.forfeited = res.forfeited || [];
      this.totals = res.totals || this.totals;
    });
  }
}


